/* ================================================================
   MENU MOBILE — Drawer Navigation Premium
   Arquitetura corrigida: submenus deslizam SOBRE o pai (overlay).
   O pai NUNCA se move. Submenu usa is-active / is-hidden.
   ================================================================ */
(function () {
  "use strict";

  // ── Referências DOM ───────────────────────────────────────
  var hamburger   = document.getElementById("menu-btn-mobile");
  var closeBtn    = document.getElementById("cd-dropdown-close");
  var dropdown    = document.querySelector(".cd-dropdown");
  var wrapper     = document.querySelector(".cd-dropdown-wrapper");
  var mainContent = document.querySelector(".cd-dropdown-content");

  if (!hamburger || !dropdown || !wrapper) return;

  // ── Toggle Hamburger ──────────────────────────────────────
  hamburger.addEventListener("click", function () {
    dropdown.classList.contains("dropdown-is-active") ? closeNav() : openNav();
  });

  // ── Botão ✕ interno ───────────────────────────────────────
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      closeNav();
      setTimeout(function () { hamburger.focus(); }, 50);
    });
  }

  // ── Fechar pelo overlay (clique fora do painel) ───────────
  wrapper.addEventListener("click", function (ev) {
    if (!dropdown.contains(ev.target)) closeNav();
  });

  // ── Fechar com ESC ────────────────────────────────────────
  document.addEventListener("keydown", function (ev) {
    if (ev.key === "Escape" && dropdown.classList.contains("dropdown-is-active")) {
      closeNav();
      setTimeout(function () { hamburger.focus(); }, 50);
    }
  });

  // ── Submenus: Abrir nível seguinte ────────────────────────
  // Arquitetura: o submenu (ul filho) desliza SOBRE o pai com is-active.
  // O pai recebe move-out para sumir os links (sem translateX no pai).
  document.querySelectorAll(".has-children > a").forEach(function (link) {
    link.addEventListener("click", function (ev) {
      ev.preventDefault();

      var submenu = link.nextElementSibling; // <ul>
      if (!submenu || submenu.tagName.toLowerCase() !== "ul") return;

      // Pai: links somem (move-out = só opacity, sem translate)
      var parentList = link.closest("ul");
      if (parentList) parentList.classList.add("move-out");

      // Submenu: entra pela direita
      submenu.classList.remove("is-hidden");
      submenu.classList.add("is-active");

      // Scroll no topo do submenu
      submenu.scrollTop = 0;
    });
  });

  // ── Botão Voltar ─────────────────────────────────────────
  document.querySelectorAll(".go-back").forEach(function (item) {
    item.addEventListener("click", function () {
      var currentList = item.closest("ul");
      if (!currentList) return;

      // Submenu: sai pela direita
      currentList.classList.remove("is-active");
      currentList.classList.add("is-hidden");

      // Pai: links voltam
      var parentHasChildren = currentList.closest(".has-children");
      if (parentHasChildren) {
        var parentList = parentHasChildren.closest("ul");
        if (parentList) parentList.classList.remove("move-out");
      }

      // Scroll no topo do nível pai
      if (mainContent) mainContent.scrollTop = 0;
    });
  });

  // ── Swipe para fechar (touch) ─────────────────────────────
  var touchStartX = 0;
  var touchStartY = 0;

  dropdown.addEventListener("touchstart", function (ev) {
    touchStartX = ev.touches[0].clientX;
    touchStartY = ev.touches[0].clientY;
  }, { passive: true });

  dropdown.addEventListener("touchend", function (ev) {
    var dx = ev.changedTouches[0].clientX - touchStartX;
    var dy = Math.abs(ev.changedTouches[0].clientY - touchStartY);
    if (dx < -60 && dy < 40) closeNav();
  }, { passive: true });

  // ── Abrir drawer ─────────────────────────────────────────
  function openNav() {
    dropdown.classList.add("dropdown-is-active");
    wrapper.classList.add("active");
    hamburger.classList.add("active");
    hamburger.setAttribute("aria-expanded", "true");
    hamburger.setAttribute("aria-label", "Fechar Menu");

    // Trava scroll do body sem layout shift
    var scrollY = window.scrollY;
    document.body.style.overflow   = "hidden";
    document.body.style.position   = "fixed";
    document.body.style.top        = "-" + scrollY + "px";
    document.body.style.width      = "100%";
    document.body.dataset.scrollY  = scrollY;
    document.body.classList.add("menu-mobile-open");
  }

  // ── Fechar drawer ─────────────────────────────────────────
  function closeNav() {
    dropdown.classList.remove("dropdown-is-active");
    wrapper.classList.remove("active");
    hamburger.classList.remove("active");
    hamburger.setAttribute("aria-expanded", "false");
    hamburger.setAttribute("aria-label", "Abrir Menu");

    // Restaura scroll sem salto
    var scrollY = parseInt(document.body.dataset.scrollY || "0", 10);
    document.body.style.overflow  = "";
    document.body.style.position  = "";
    document.body.style.top       = "";
    document.body.style.width     = "";
    window.scrollTo(0, scrollY);
    document.body.classList.remove("menu-mobile-open");

    // Reseta submenus após a transição do painel
    dropdown.addEventListener("transitionend", resetSubmenus, { once: true });
  }

  // ── Reset de todos os submenus ────────────────────────────
  function resetSubmenus() {
    // Coloca todos os submenus de volta no estado oculto
    document.querySelectorAll(".cd-dropdown-content ul").forEach(function (ul) {
      ul.classList.remove("is-active");
      ul.classList.add("is-hidden");
    });
    // Remove move-out de qualquer lista
    document.querySelectorAll(".move-out").forEach(function (el) {
      el.classList.remove("move-out");
    });
  }

  // ── Inicialização ─────────────────────────────────────────
  // Garante que todos os submenus começam no estado correto
  document.querySelectorAll(".cd-dropdown-content ul").forEach(function (ul) {
    ul.classList.add("is-hidden");
    ul.classList.remove("is-active");
  });

})();
